/* MoRetro Studio V11 — Analyzer Safe
   L'analyse automatique n'est plus utilisée pour calculer un devis.
   On garde seulement une détection propre du fichier.
*/
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  window.MTS_ANALYZER_VERSION = "V11 Manual Safe";
  console.info("MoRetro Studio Analyzer:", window.MTS_ANALYZER_VERSION);

  async function analyzeFile(file){
    const name = String(file.name || "").toLowerCase();
    const ext = (name.split(".").pop() || "").toUpperCase();

    return {
      analyzable:false,
      manual:true,
      fileName:file.name || "Fichier",
      fileType:ext,
      dimensions:null,
      volumeCm3:0,
      bboxVolumeCm3:0,
      triangles:0,
      error:"Analyse automatique désactivée. Utilise les valeurs fiables du slicer.",
      metadata:{
        source:"Saisie manuelle",
        fileSize:file.size || 0
      }
    };
  }

  MTS.Analyzer = { analyzeFile };
})(window.MTS);
